import { useToken } from "src/business-hooks/useToken";
import { useQueryUsersPublic } from "src/queries/users/users.query";
import type { UserPublic } from "src/queries/users/users.types";
import type { AccessTokenClaims } from "src/utils/auth/auth-schema";

export const useCurrentUser = (): Partial<UserPublic & AccessTokenClaims> => {
  const token = useToken();

  const currentUserQuery = useQueryUsersPublic<UserPublic & AccessTokenClaims>({
    queryKey: ["currentUser", token.loggedInUser?.user_id],
    // Keep select function pure (no side effects) for React Query optimization.
    // React Compiler will automatically memoize this inline function based on its dependencies.
    select: (data) => {
      const currentUser = data.find(
        (user) =>
          token.loggedInUser?.user_id && user.user_id === token.loggedInUser!.user_id
      ) as UserPublic;

      // API user profile wins over decoded token claims; stale E2E storage may contain
      // legacy name fields in the JWT payload.
      return { ...(token.loggedInUser as AccessTokenClaims), ...currentUser };
    },
    enabled: !!token.loggedInUser,
  });

  return currentUserQuery.data || {};
};
